import { Autocomplete, Button, Menu, MenuItem, Tab, Tabs, TextField } from '@mui/material'
import logo from '../logo.svg'
import {
  Add,
  AdminPanelSettingsOutlined,
  AssignmentIndOutlined,
  BeenhereOutlined,
  ContentPasteOutlined,
  PersonOutlineOutlined,
} from '@mui/icons-material'
import './NavBar.css'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useContext, useState } from 'react'
import { dataContext } from '..'
import NewQuoteDialog from '../NewQuote/NewQuote'

export default function NavBar() {
  const location = useLocation()
  const navigate = useNavigate()
  const { user } = useContext(dataContext)

  const [newQuoteOpen, setNewQuoteOpen] = useState(false)
  const [complianceMenuAnchor, setComplianceMenuAnchor] = useState<null | HTMLElement>(null)

  return (
    <div className="nav-bar">
      <div className="nav-bar-left">
        <img src={logo} alt="logo" />
        <Tabs value="quote">
          <Tab
            value="quote"
            icon={<ContentPasteOutlined />}
            iconPosition="start"
            label="Quote"
            onClick={() => navigate('/quotes')}
          />
          <Tab
            value="repcodes"
            icon={<AssignmentIndOutlined />}
            iconPosition="start"
            label="Rep Codes"
            onClick={() => navigate('/repcodes')}
          />
          <Tab
            value="compliance"
            icon={<BeenhereOutlined />}
            iconPosition="start"
            label="Compliance"
            onClick={e => setComplianceMenuAnchor(e.currentTarget)}
          />
          <Tab
            value="admin"
            icon={<AdminPanelSettingsOutlined />}
            iconPosition="start"
            label="Admin"
            onClick={() => navigate('/admin')}
          />
        </Tabs>

        <Menu
          anchorEl={complianceMenuAnchor}
          open={Boolean(complianceMenuAnchor)}
          onClose={() => setComplianceMenuAnchor(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <MenuItem
            component={Link}
            to="/compliance/vendors"
            onClick={() => setComplianceMenuAnchor(null)}
            selected={location.pathname.includes('vendors')}
          >
            OEM / Vendors
          </MenuItem>
          <MenuItem
            component={Link}
            to="/compliance/vehicles"
            onClick={() => setComplianceMenuAnchor(null)}
            selected={location.pathname.includes('vehicles')}
          >
            Contract Vehicles
          </MenuItem>
          <MenuItem
            component={Link}
            to="/catalogs"
            onClick={() => setComplianceMenuAnchor(null)}
            selected={location.pathname === '/catalogs'}
          >
            Catalogs
          </MenuItem>
          <MenuItem
            component={Link}
            to="/compliance/tr"
            onClick={() => setComplianceMenuAnchor(null)}
            selected={location.pathname.includes('tr')}
          >
            TR / TRPs
          </MenuItem>
          <MenuItem
            component={Link}
            to="/supplier"
            onClick={() => setComplianceMenuAnchor(null)}
            selected={location.pathname === '/supplier'}
          >
            Suppliers
          </MenuItem>
          <MenuItem
            component={Link}
            to="/manufacturer"
            onClick={() => setComplianceMenuAnchor(null)}
            selected={location.pathname === '/manufacturer'}
          >
            Manufacturers
          </MenuItem>
          <MenuItem
            component={Link}
            to="/gsamascatalog"
            onClick={() => setComplianceMenuAnchor(null)}
            selected={location.pathname === '/gsamascatalog'}
          >
            GSA MAS Catalog
          </MenuItem>
        </Menu>
      </div>
      <div className="nav-bar-right">
        <div>
          <Autocomplete
            options={[]}
            renderInput={params => <TextField {...params} label="Search" />}
            size="small"
            fullWidth
          />
          <Button variant="contained" startIcon={<Add />} onClick={() => setNewQuoteOpen(true)}>
            New Quote
          </Button>
          <NewQuoteDialog open={newQuoteOpen} onClose={() => setNewQuoteOpen(false)} />
        </div>
        <Button disabled startIcon={<PersonOutlineOutlined />}>
          {user.displayName}
        </Button>
      </div>
    </div>
  )
}
